import React, { useState, useEffect, useRef } from 'react';
import { FaLinkedin, FaEnvelope, FaBriefcase } from 'react-icons/fa';
import { GRADIENTS, COLORS } from './themeConstants';
import { useHistory } from 'react-router-dom';

const CEO = {
	name: 'Uvais K T',
	position: 'Founder and CEO',
	email: 'contact@necttos.com',
	linkedin: 'https://in.linkedin.com/in/uvais-k-t-a2769a218',
	// portfolio: 'https://necttos.com/ceo',
	phone: '+91 7012301380',
	bio: 'Uvais K T is a passionate Full Stack Developer and the CEO of Necttos, with over 4 years of experience in JavaScript, MERN stack development, and deep hands-on expertise in college administration systems and accounts. From 2017 to 2022, during his time with AMC Group of Educational Institutions, he gained practical experience in managing college operations, which helped him understand the real challenges faced by institutions. This inspired him to start building software solutions tailored for colleges, combining his technical knowledge with ground-level experience. A postgraduate in Commerce, Uvais is a rare all-rounder in both the tech and education fields. His work has earned him awards like the Best Student Award from Calicut University, the MLA Excellence Award from Shri. K. Krishnankutty, and the Best Student Entrepreneur Award from AMC Group. Under his leadership, Necttos became the first officially approved startup under the University of Calicut, a proud milestone featured in Deshabhimani, Kaumudi, and Malayala Manorama. Uvais continues to lead with a vision to innovate, simplify, and strengthen educational systems through smart IT solutions.',
	photo: 'https://media.licdn.com/dms/image/v2/D5603AQEVRQJ_sjc8Ag/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1721656900646?e=2147483647&v=beta&t=JJ9EQ8EoGaJJbXErQtoq1CI8dQp8a54Ls-3YEflb6vU',
	awards: [
		{
			name: 'AMC Group of Educational Institutions, Manissery',
			title: 'Performance Appreciation Award – NAAC 2022',
			date: 'April 26, 2022',
			description: 'Honored for exceptional contributions in IT Support during NAAC 2022, including data structuring coordination and streamlining of digital management systems. Awarded by AMC Group of Educational Institutions, affiliated to the University of Calicut.',
		},
		{
			name: 'AMC Group of Educational Institutions, Manissery',
			title: 'Best Student Entrepreneur – Merit Day 2023',
			date: 'October 4, 2023',
			description: 'Recognized as Best Student Entrepreneur during Merit Day for the M.Com Finance (2021–2023) batch. Awarded by AMC Group of Educational Institutions, affiliated to the University of Calicut, celebrating innovation, leadership, and academic excellence.',
		},
		{
			name: 'Calicut University',
			title: 'Best Student Startup Award 2024',
			date: 'January 16, 2024',
			description: 'Received the Excellence in Innovation and Leadership Award from Shri. P. A. Mohammed Riyas, Minister for Public Works and Tourism, Government of Kerala. This honor recognizes outstanding contributions to technological innovation and community leadership.',
		},
		{
			name: 'Pattambi Municipality',
			title: 'MLA Excellence Award',
			date: 'June 21, 2024',
			description: 'Presented by Shri. K. Krishnankutty (M. Ele.), Minister for Electricity, Government of Kerala. Awarded for leadership, service, and innovation impacting the community through technology and entrepreneurship.',
		},
		{
			name: 'Deshabhimani | Kaumudi | Malayala Manorama',
			title: 'Media Recognition – First University Startup',
			date: '2024',
			description: 'Necttos became the first officially recognized startup under the University of Calicut, a historic milestone featured across major newspapers. A symbol of student-led innovation and digital transformation.',
		},
	],
};

const coordinators = [
	{
		name: 'AMALU KURUVILLA',
		position: 'Full Stack Developer – Entrepreneurial Focus',
		photo: 'https://media.licdn.com/dms/image/v2/D4E03AQHQDP7knD0KuA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1723272916632?e=1753315200&v=beta&t=MWiAmktwD4dTgHdX_fhlHAcj6vK9JcSdnFPsdZP4nOI',
		linkedin: 'https://www.linkedin.com/in/-amalukuruvilla-/',
	},
	{
		name: 'NIVIN SHAS',
		position: 'Full Stack Developer – Entrepreneurial Focus',
		photo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/IMG_0819%20(1).jpg?alt=media&token=d53597c7-80f1-48b2-84cb-7ea2621f7108',
		linkedin: 'https://www.linkedin.com/in/nivin-shas/',
	},
	{
		name: 'ANU BENNY',
		position: 'Full Stack Developer – Entrepreneurial Focus',
		photo: 'https://media.licdn.com/dms/image/v2/D4E03AQESz_Qqnnu6wA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1723471081281?e=1753315200&v=beta&t=Vr-ICo9WcG7wvHoK5SWVH6R4hT_tU96jYQXmDWu38fI',
		linkedin: 'https://www.linkedin.com/in/anu-benny-2900352b3/',
	},
	{
		name: 'HASHIM HUSAIN',
		position: 'Full Stack Developer – Entrepreneurial Focus',
		photo: 'https://media.licdn.com/dms/image/v2/D4E03AQE96PEhhIivPQ/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1676630704040?e=1751500800&v=beta&t=3lErxosGHcmZ5QD_4TGNSgCOyJTsFjjQoKBx9yhT0a4',
		linkedin: 'https://www.linkedin.com/in/hashim-husain/',
	},
	{
		name: 'ABHIRAM KRISHNA',
		position: 'Full Stack Developer – Entrepreneurial Focus',
		photo: 'https://media.licdn.com/dms/image/v2/D5603AQFU-ZNZRBwEzQ/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1718242518365?e=1753315200&v=beta&t=WLiFD12JzLzgEuvRcNY5QO7Vj_PrUQ3C1THZJpeGyiM',
		linkedin: 'https://www.linkedin.com/in/abhiram-krishna2002/',
	},
	{
		name: 'THOMAS PS',
		position: 'Full Stack Developer – Entrepreneurial Focus',
		photo: 'https://media.licdn.com/dms/image/v2/D5603AQGaNczDhxa9TA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1728637849408?e=1753315200&v=beta&t=CgHoi3H7EYSKSf8Fc9IeGOWY72YXJfYMeOc0zec_kz4',
		linkedin: 'https://www.linkedin.com/in/thomas-ps-546574332/',
	},
	{
		name: 'HASHIM A',
		position: 'Full Stack Developer – Entrepreneurial Focus',
		photo: 'https://media.licdn.com/dms/image/v2/D5603AQGCdtrHASWoLg/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1730271953966?e=1751500800&v=beta&t=C1th9ZDHwW-M8mAyuq-xcHTJyR7f_yH0kt_q5oui9WA',
		linkedin: 'https://www.linkedin.com/in/hashim-a-139a00269/',
	},

	{
		name: 'AVINASH DINESH',
		position: 'Full Stack Developer – Entrepreneurial Focus',
		photo: 'https://media.licdn.com/dms/image/v2/D5603AQHp5l_ssoetsg/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1728065838866?e=1753315200&v=beta&t=tjqlrdymIgBucYMhYqXyk5-kr_iQ7gaxsmExbMJbDwE',
		linkedin: 'https://www.linkedin.com/in/avinash-dinesh-84bb2b231/',
	},
	{
		name: 'GOPIKA K',
		position: 'Full Stack Developer – Entrepreneurial Focus',
		photo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/PHOTO-2025-05-22-11-48-05.jpg?alt=media&token=739f9e72-564e-4728-8ab2-a27307f5b298',
		linkedin: 'https://www.linkedin.com/in/gopika-k-36b83a337/',
	},
];

const studentMembers = [
	{
		name: 'Pranav P S',
		position: 'Junior Full Stack Developer (Student – Entrepreneurial Track)',
		photo: 'https://media.licdn.com/dms/image/v2/D5603AQFwvdI5hOIDBA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1703500427122?e=1750291200&v=beta&t=Qbe4ugTOMgrKE8Dme9q5wxG70APClw95znxife4V920',
		linkedin: 'https://www.linkedin.com/in/pranav-wright/',
		collegeName: "2023-26 BCA St. Mary's College,Sulthan Bathery",
	},
	{
		name: 'Santhipriyan V G',
		position: 'Junior UI/UX Designer (Student – Entrepreneurial Track)',
		photo: 'https://media.licdn.com/dms/image/v2/D4E03AQEdxTiZkntgnQ/profile-displayphoto-shrink_800_800/B4EZYzccX2HgAk-/0/1744619818269?e=1750291200&v=beta&t=6ArW_y1DACyTWvm8UkY025nbqdQj8EV4Std8hWeJ76g',
		linkedin: 'https://www.linkedin.com/in/santhipriyan-vg-32074334b/',
		collegeName: "2023-26 BCA St. Mary's College,Sulthan Bathery",
	},
	{
		name: 'Abdul Basith P V',
		position: 'Junior Full Stack Developer (Student – Entrepreneurial Track)',
		photo: 'https://media.licdn.com/dms/image/v2/D5603AQEGtuBkUMyLJQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1727436949554?e=1750896000&v=beta&t=QPKl_3K5rN1hD8-2Bl6rmgVeZTEds-VzItC1NZtXwis',
		linkedin: 'https://www.linkedin.com/in/abdulbasithpv/',
		collegeName: '2024-28 B.Tech, VIMAL JYOTHY ENGINEERING COLLEGE',
	},
	{
		name: 'SONIYA VILAS',
		position: 'Junior Full Stack Developer (Student – Entrepreneurial Track)',
		photo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/Screenshot%202025-06-14%20at%207.36.04%E2%80%AFPM.png?alt=media&token=a9172801-4b65-4035-b7f7-2b18d0290616',
		linkedin: 'https://www.linkedin.com/in/soniya-vilas-471464328/',
		collegeName: '2024-28 B.Tech, VIMAL JYOTHY ENGINEERING COLLEGE',
	},
];
const accadamic = [
	{
		name: 'Prof. Dr. Mohamed Shahin Thayyil',
		collegeName: 'Physics Department, University of Calicut',
		position: 'Faculty Advisor – Necttos Mentorship',
		photo: 'https://physics.uoc.ac.in/images/Faculty_Members/MShahin/IMG_5453.JPG',
		linkedin: 'https://physics.uoc.ac.in/index.php/2-uncategorised/60-shahin',
	},
	{
		name: 'Dr. Sirajudheen K K',
		collegeName: 'WMO Atrs and Science College, Muttil',
		position: 'Faculty Advisor – Necttos Mentorship',
		photo: 'https://storage.googleapis.com/necttos-production.appspot.com/users/NT-DF0FADB98B53-47D4-8D56-313B7D1FD008/avatar.jpg?GoogleAccessId=firebase-adminsdk-iniha%40necttos-production.iam.gserviceaccount.com&Expires=82669420800&Signature=PjPFi1TwjUd%2FUTGYkgOY4vZJIKG98Vu1s4SbRzm%2FH%2BYB7tPZixewIERgZM6d5NAOP7JTy2F%2B%2FhJwlO6U7Z6Us9ItCYmw9ot9uxCJX%2BDZ4JhDrFnWkamywqnaG4BcX8WYMgEZj8nVdHfU5fmu9f8OPUII3jB6Z2%2Fjwq7%2BcuXoRBcBUezk6fRz368gkQKjVU%2B%2F1wARykjOuk1VaRQtaGxIrVGSzFPMFfgVbS3QsMe1haAHpLHRHm9svchice6jqsqkcQMnzJH4tYE2pzN8nq%2FusOhUVaA04%2B4GA6K2SDaIZlk6AMGJvtRuEss%2F6%2FsqcH6MTyMIEpxc5xK6iVmaYBSCkw%3D%3D',
		linkedin: 'https://www.linkedin.com',
	},
	{
		name: 'Prof. Francis Thomas',
		collegeName: 'ST. DOMINIC’S COLLEGE, KANJIRAPALLY',
		position: 'Faculty Advisor – Necttos Mentorship',
		photo: 'https://firebasestorage.googleapis.com/v0/b/necttos-production.appspot.com/o/users%2FNT-1D0620108120-47FA-9854-D77E00176845%2Favatar.jpg?alt=media&token=17bef6cc-1e78-403b-a3bd-0e7b8a43c206',
		linkedin: 'https://www.sdck.in/teachingstaff.php',
	},
];

const mentors = [
	{
		name: 'Nishad Najimudeen',
		collegeName: 'Senior Developer at Ralph Lauren',
		position: 'Senior React Native Developer',
		photo: 'https://media.licdn.com/dms/image/v2/C5603AQECVyQ9cx97jQ/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1631388131907?e=1750291200&v=beta&t=GGRCZFtF8P1X6-SWznI2rIGq-7edVP7pbltZgapvkNc',
		linkedin: 'https://www.linkedin.com/in/nishadonline/',
	},
	{
		name: 'Tody Sudan',
		collegeName: 'Lead I - Software Engineering at UST',
		position: 'Senior Node Js Developer',
		photo: 'https://media.licdn.com/dms/image/v2/D5603AQF9pcaGpnFebA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1707034159804?e=1750291200&v=beta&t=hStGId8o850MZt-UetG0Dq-WaoPnKwmCJK2ueXa9hV8',
		linkedin: 'https://www.linkedin.com/in/toby-sudan/',
	},
	{
		name: 'Jerin Joy ',
		collegeName: 'Senior DevOps Engineer at Zed Mobility',
		position: 'Senior DevOps Engineer',
		photo: 'https://media.licdn.com/dms/image/v2/D5603AQEK2X7z-WAQcw/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1705773883206?e=1750291200&v=beta&t=wJcYqNLHbgDm-icJQECeMKUvNhzYsHm4q96jsl0IxN8',
		linkedin: 'https://www.linkedin.com/in/jerin-jt/',
	},
	{
		name: 'Navaf Muhammed ',
		collegeName: 'Product Designer | UI/UX Design | SaaS | AI',
		position: 'Senior UIUX Designer',
		photo: 'https://navafmuhammed.me/images/photo_2022-11-01_23-00-49.jpg',
		linkedin: 'https://www.linkedin.com/in/navafmuhammed/',
	},
];

const LeaderCard = ({ leader }) => (
	<div className='relative group flex justify-center'>
		<div className={`overflow-hidden rounded-3xl p-10 lg:p-12 w-full max-w-[400px] lg:max-w-[640px] ${COLORS.background.glass} backdrop-blur-lg transition duration-300 hover:shadow-2xl`}>
			<div className='flex flex-col items-center'>
				<div className='relative group'>
					<img src={leader.photo} alt={leader.name} className='relative h-48 w-48 lg:h-64 lg:w-64 rounded-full object-cover ring-4 ring-white dark:ring-gray-800 transition-transform duration-300 ease-in-out group-hover:scale-105 group-hover:shadow-lg' />
				</div>

				<h2 className={`mt-10 text-3xl lg:text-4xl font-bold bg-gradient-to-r ${GRADIENTS.text.accent} bg-clip-text text-transparent`}>{leader.name}</h2>
				<p className={`text-xl lg:text-2xl m-4 ${COLORS.text.secondary}`}>{leader.position}</p>
				<p className={`mt-18 text-center text-base lg:text-lg ${COLORS.text.secondary} leading-relaxed`}>{leader.bio}</p>
				<div className='mt-12 flex flex-wrap justify-center gap-6'>
					<a href={leader.linkedin} target='_blank' rel='noopener noreferrer' className={`flex items-center gap-2 rounded-full bg-gradient-to-r ${GRADIENTS.button.primary} px-6 py-3 text-base lg:text-lg text-white transition transform hover:-translate-y-1 hover:scale-105 hover:shadow-xl duration-300 no-underline hover:no-underline`}>
						<FaLinkedin size={20} />
						LinkedIn
					</a>

					<a href={`mailto:${leader.email}`} className={`flex items-center gap-2 rounded-full bg-gradient-to-r ${GRADIENTS.button.secondary} px-6 py-3 text-base lg:text-lg text-white transition transform hover:-translate-y-1 hover:scale-105 hover:shadow-xl duration-300 no-underline hover:no-underline`}>
						<FaEnvelope size={20} />
						Email
					</a>

					<a href={'/ceo'} className={`flex items-center gap-2 rounded-full bg-gradient-to-r ${GRADIENTS.button.secondary} px-6 py-3 text-base lg:text-lg text-white transition transform hover:-translate-y-1 hover:scale-105 hover:shadow-xl duration-300 no-underline hover:no-underline`}>
						<FaBriefcase size={20} />
						Portfolio
					</a>
				</div>
			</div>
		</div>
	</div>
);

const AwardCard = ({ award }) => (
	<div className={`rounded-xl ${COLORS.background.glass} p-6 shadow-lg backdrop-blur-sm transition duration-300 hover:shadow-2xl hover:-translate-y-1 hover:scale-105 ${COLORS.border.glass}`}>
		<h3 className={`text-xl font-bold bg-gradient-to-r ${GRADIENTS.text.accent} bg-clip-text text-transparent`}>{award.name}</h3>
		<p className={`${COLORS.text.primary}`}>{award.title}</p>
		{award.date && <p className={`text-sm ${COLORS.text.secondary}`}>{award.date}</p>}
		<p className={`mt-2 ${COLORS.text.secondary}`}>{award.description}</p>
	</div>
);

const TeamMemberCard = ({ member }) => (
	<div className='group relative flex flex-col h-full'>
		<div className={`overflow-hidden rounded-xl ${COLORS.background.glass} p-6 shadow-lg backdrop-blur-sm transition duration-200 hover:shadow-xl ${COLORS.border.glass} flex flex-col h-full`}>
			<div className='flex flex-col items-center flex-grow'>
				<div className='relative'>
					<img src={member.photo} alt={member.name} className='relative h-24 w-24 rounded-full object-cover ring-2 ring-white/50 dark:ring-gray-800/50' />
				</div>
				<h3 className={`mt-4 text-lg font-semibold bg-gradient-to-r ${GRADIENTS.text.accent} bg-clip-text text-transparent`}>{member.name}</h3>
				<p className={`text-sm ${COLORS.text.secondary}`}>{member.position}</p>
				<p className={`text-sm ${COLORS.text.secondary}`}>{member.collegeName}</p>

				{/* Push LinkedIn button to bottom */}
				<div className='mt-auto pt-6'>
					<a
						target='_blank'
						rel='noopener noreferrer'
						href={member.linkedin}
						className={`inline-flex items-center gap-2 text-sm font-semibold px-6 py-3 rounded-full
            bg-gradient-to-r ${GRADIENTS.button.primary}
            text-white hover:shadow-xl transition-transform transform
            hover:translate-y-[-4px] duration-300 no-underline`}>
						<FaLinkedin size={18} className='mr-2' />
						<span>LinkedIn</span>
					</a>
				</div>
			</div>
		</div>
	</div>
);

const VisionaryLeader = () => {
	const [isVisible, setIsVisible] = useState(false);
	const [joinOurTeam, setJoinOurTeam] = useState({
		entrepreneur: false,
		student: false,
		teacher: false,
		techMember: false,
	});

	const history = useHistory();
	const handleNav = () => {
		window.location.href = '/career';
	};

	const sectionRef = useRef(null);

	useEffect(() => {
		let timeout;
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setIsVisible(true);
					observer.disconnect();
				}
			},
			{
				threshold: 0.1,
				rootMargin: '0px 0px -10% 0px',
			},
		);

		if (sectionRef.current) {
			observer.observe(sectionRef.current);
		}

		timeout = setTimeout(() => {
			setIsVisible(true);
		}, 1000);

		return () => {
			if (sectionRef.current) {
				observer.unobserve(sectionRef.current);
			}
			observer.disconnect();
			clearTimeout(timeout);
		};
	}, []);

	return (
		<section id='team' ref={sectionRef} className={`py-32 bg-gradient-to-br ${GRADIENTS.background.primary} overflow-hidden`}>
			<div className='mx-auto max-w-7xl px-6 lg:px-8'>
				<div className='mb-32 grid gap-20 lg:grid-cols-2'>
					<div className={`transition duration-200 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`}>
						<LeaderCard leader={CEO} />
					</div>
					<div className={`space-y-6 transition duration-200 ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}`}>
						<h2 className={`text-3xl font-bold bg-gradient-to-r ${GRADIENTS.text.accent} bg-clip-text text-transparent`}>Awards & Recognition</h2>
						{CEO.awards.map((award, index) => (
							<AwardCard key={index + 'oocc'} award={award} />
						))}
					</div>
				</div>
				<div id='team1' className={`transition duration-300  mb-9 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
					<h2 className={`mb-2 text-center h-16text-4xl lg:text-5xl font-bold bg-gradient-to-r ${GRADIENTS.text.accent} bg-clip-text text-transparent`}>Tech & Innovation Team</h2>
					<p className='max-w-4xl mx-auto text-center text-lg text-gray-600 dark:text-gray-300 leading-relaxed mb-6 px-4'>Our Tech & Innovation Team is the engine behind Necttos. Made up of talented developers, designers, and creative minds, this team works day and night to build smart, scalable systems for the education sector. From coding platforms to solving real-time issues, they ensure colleges run smoothly with the help of technology.</p>
					<div className='text-center mb-14'>
						<button
							className='bg-[#004BAD] hover:bg-[#003B9C] text-white font-semibold py-3 px-6 rounded-xl transition-all shadow-md'
							onClick={() => {
								setJoinOurTeam({ ...joinOurTeam, entrepreneur: !joinOurTeam.entrepreneur });
							}}>
							Join Our Team
						</button>
					</div>
					{joinOurTeam.entrepreneur && (
						<div className='max-w-4xl mb-12 mx-auto p-6 bg-white dark:bg-gray-900 rounded-2xl shadow-md'>
							<h2 className='text-3xl font-bold text-center text-blue-700 dark:text-blue-400 mb-6'>Join Our Team</h2>

							<p className='text-lg text-gray-700 dark:text-gray-300 mb-4 font-semibold'>📄 Required Documents:</p>
							<ul className='list-disc list-inside text-gray-600 dark:text-gray-400 space-y-2 mb-6'>
								<li>SSLC Mark List & Certificate</li>
								<li>Plus Two Mark List & Certificate</li>
								<li>Degree Certificate & Consolidated Mark List</li>
								<li>Other Academic or Non-Academic Achievements</li>
								<li>Updated CV / Resume</li>
								<li>LinkedIn Profile (if available)</li>
							</ul>

							<p className='text-lg text-gray-700 dark:text-gray-300 mb-4 font-semibold'>📧 How to Apply:</p>
							<ul className='list-disc list-inside text-gray-600 dark:text-gray-400 space-y-2 mb-6'>
								<li>
									Email all documents to: <span className='text-blue-600 dark:text-blue-400 font-medium'>contact@necttos.com</span>
								</li>
								<li>
									Call us at <span className='text-blue-600 dark:text-blue-400 font-medium'>80000 41733</span> for an introduction & phone interview
								</li>
								<li>Further steps will be guided after the initial interaction</li>
							</ul>
						</div>
					)}

					<div className='grid gap-12'>
						<div className='grid gap-8 sm:grid-cols-2 lg:grid-cols-3 align-center'>
							{coordinators.map((member, index) => (
								<TeamMemberCard key={index + 'tt'} member={member} />
							))}
						</div>
						 
					</div>
				</div>
				<div id='team2' className={`transition duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
					<h2 className={`mb-2 text-center p-2 text-4xl lg:text-5xl font-bold bg-gradient-to-r ${GRADIENTS.text.accent} bg-clip-text text-transparent`}>🎓 Empowering Students through Necttos</h2>
					<p className='max-w-4xl mx-auto text-center text-lg text-gray-600 dark:text-gray-300 leading-relaxed mb-4 px-4'>Necttos, now a successful startup registered under the University of Calicut, began as a dream in 2014 during the founder’s second year of B.Com. Faced with academic challenges and no technical support to develop his solution, he held onto the idea and fought to bring it to life. That determination led to the official launch of Necttos on March 5, 2021. Today, with steady revenue and institutional recognition, the founder has committed his life to supporting students—helping them overcome what he once faced. Through mentorship, financial aid, and innovation support, Necttos empowers students to achieve their goals and build a stronger future.</p>
					<div className='text-center mb-14'>
						<button
							className='bg-[#004BAD] hover:bg-[#003B9C] text-white font-semibold py-3 px-6 rounded-xl transition-all shadow-md'
							onClick={() => {
								setJoinOurTeam({ ...joinOurTeam, student: !joinOurTeam?.student });
							}}>
							Join Our Team
						</button>
					</div>
					{joinOurTeam?.student && (
						<div id='team3' className='max-w-4xl mx-auto p-6 bg-white dark:bg-gray-900 rounded-2xl shadow-md m-4'>
							<h2 className='text-3xl font-bold text-center text-blue-700 dark:text-blue-400 mb-6'>Join Our Student Engagement Team</h2>

							<p className='text-lg text-gray-700 dark:text-gray-300 mb-4 font-semibold'>👨‍🎓 Who Can Apply:</p>
							<ul className='list-disc list-inside text-gray-600 dark:text-gray-400 space-y-2 mb-6'>
								<li>Students pursuing BCA, B.Sc CS, or B.Tech CS</li>
								<li>Must have a personal laptop</li>
								<li>Basic knowledge of programming is expected</li>
								<li>We're here to boost you towards your tech career goals</li>
							</ul>

							<p className='text-lg text-gray-700 dark:text-gray-300 mb-4 font-semibold'>📄 Required Documents:</p>
							<ul className='list-disc list-inside text-gray-600 dark:text-gray-400 space-y-2 mb-6'>
								<li>SSLC Mark List</li>
								<li>Plus Two Mark List</li>
								<li>Latest Semester Mark List</li>
								<li>Updated CV / Resume</li>
							</ul>

							<p className='text-lg text-gray-700 dark:text-gray-300 mb-4 font-semibold'>📧 How to Apply:</p>
							<ul className='list-disc list-inside text-gray-600 dark:text-gray-400 space-y-2 mb-6'>
								<li>
									Email all documents to: <span className='text-blue-600 dark:text-blue-400 font-medium'>contact@necttos.com</span>
								</li>
								<li>
									Call us at <span className='text-blue-600 dark:text-blue-400 font-medium'>80000 41733</span> for a quick introduction & phone interview
								</li>
								<li>Next steps will be guided after the initial interaction</li>
							</ul>
						</div>
					)}

					<div id='team4' className='grid gap-12 mb-5'>
						<div className='grid gap-8 sm:grid-cols-2 lg:grid-cols-3 align-center'>
							{studentMembers.map((member, index) => (
								<TeamMemberCard key={index + 'qq'} member={member} />
							))}
						</div>
					</div>
				</div>
				<div id='team5' className={`transition duration-1000 mb-5 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
					<h2 className={`relative mb-6 text-center text-4xl md:text-5xl font-extrabold bg-gradient-to-r ${GRADIENTS.text.accent} bg-clip-text text-transparent leading-none pb-4`}>🎯 Faculty Mentors Supporting Innovation</h2>
					<p className='max-w-4xl mx-auto text-center text-lg text-gray-600 dark:text-gray-300 leading-relaxed mb-4 px-4'>At Necttos, our faculty mentors are the driving force behind our stability and innovation. They actively support us in managing platform reliability, guiding the development of new features, and shaping robust solutions for academic challenges. By identifying pain points in education workflows and helping translate them into smart, scalable innovations, they ensure Necttos continues to grow as a resilient and forward-thinking platform.</p>
					<div className='grid gap-12'>
						<div className='grid gap-8 sm:grid-cols-2 lg:grid-cols-3 align-center'>
							{accadamic.map((member, index) => (
								<TeamMemberCard key={index + 'ww'} member={member} />
							))}
						</div>
					</div>
				</div>
				<div id='team6' className={`transition duration-1000 mb-5 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
					<h2 className={`relative mb-6 text-center text-4xl md:text-5xl font-extrabold bg-gradient-to-r ${GRADIENTS.text.accent} bg-clip-text text-transparent leading-none pb-4`}>🎯 Industry Mentors Supporting Innovation</h2>
					<p className='max-w-4xl mx-auto text-center text-lg text-gray-600 dark:text-gray-300 leading-relaxed mb-5 px-4'>Our industry mentors bring real-world experience and market insight to Necttos. These professionals from various fields help bridge the gap between academics and industry needs. With their mentorship, our team stays updated, practical, and ready to build solutions that truly matter in today’s world.</p>
					<div className='grid gap-12'>
						<div className='grid gap-8 sm:grid-cols-2 lg:grid-cols-3 align-center'>
							{mentors.map((member, index) => (
								<TeamMemberCard key={index + 'bb'} member={member} />
							))}
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default VisionaryLeader;
